/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FaceConfigurationOffSpringDto } from "./FaceConfigurationOffSpringDto";
import { Side } from "../Side";
import { SectionFragmentDto } from "./SectionFragmentDto";

export class FaceDto extends FaceConfigurationOffSpringDto {
    id: string;
    side: Side;
    sectionFragments: SectionFragmentDto[];
}
